import React, {
	Component
} from 'react';

import { store } from '../stores/mainStore';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { motion, AnimatePresence} from "framer-motion";
import { min } from 'lodash';
import { integration } from '../integration';
import { Sprite } from './Sprite';

const Positioner = styled.div`
	position: relative;
	width: 100%;
	height: 100vw;
	overflow: visible;
	pointer-events: none;
`

const Top = styled.div`
	position: fixed;
	top: 15vw;
	left: 0;
	height: auto;
	width: 100%;
	overflow: hidden;
	display: flex;
	justify-content: center;
	z-index: 1000;
	pointer-events: none;

`

const AchievementToastBody = styled(motion.div)`
	font-size: 5vw;
	background-image: ${({color}) => `url('/assets/achievements/achievement_toast_${color}.png')`};
	background-size: 100%;
	height: 29.5vw;
	width: 100vw;
	top: 0;
	left: 0;
	position: absolute;
	pointer-events: initial;
	color: white;
	text-shadow: 0.3vw 0.3vw 0.3vw black;
`

// const Inner = styled.div`
// 	position: relative;
// 	height: 100%;
// 	width: 100%;
// `

// const Name = styled.div`
// 	position: absolute;
// 	top:14vw;
// 	left: 30.5vw;
// 	width: 59%;
// 	text-align:center;
// 	white-space:nowrap;
// `

// const Xp = styled.div`
// 	position: absolute;
// 	bottom: 4vw;
// 	left: 2vw;
// 	width: 24vw;
// 	text-align: center;
// 	font-size: 0.8em;
// `

class AchievementToast extends Component {

	constructor(props){
		super(props);
		integration.postAnalyticsEvent(`achievement_show`, `economy`, props.toast.Data.Achieve);
	}

	clickable = false;

	view = (key) => {
		// history.push('/achievements');
		if(this.clickable){
			window.manager.playAudio("poopPop");
			integration.postAnalyticsEvent(`achievement_click`, `economy`, this.props.toast.Data.Achieve);
			store.showAchievements = true;
			// store.setSeenNotification(key);
			store.seenNotifications = store.rewards.map(r => r.ConfirmationKey);
			store.rewards = [];
		}
	}

	seen(key){
		this.clickable = true;
		setTimeout(() => store.setSeenNotification(key), 2500);
	}

	render(){
		var toast = this.props.toast;
		var lvl = min([toast.Data.AchieveLevel - 1, 2]) || 0;
		var color = ["bronze","silver","gold"][lvl];
		if(!color){
			// debugger;
		}
		return (
			<AchievementToastBody
				key={toast.ConfirmationKey}
				initial={{ top: '-30vw' }}
				animate={{ top: '0vw', transition: {type: 'tween', delay: 1} }}
				exit={{ top: '-30vw', transition: {type: 'tween'} }}
				onAnimationComplete={this.seen.bind(this, toast.ConfirmationKey)}
				onClick={this.view.bind(this, toast.ConfirmationKey)}
				color={color}
			>
				<Sprite w={100} localize sprite="achievement_toast.png"/>
				{/* <Inner>
					<Xp>+{toast.Data.xp}XP</Xp>
					<Name>{i18n.t('ach-'+toast.Data.Achieve)} </Name>
				</Inner> */}
			</AchievementToastBody>
		);
	}
}


@observer
export class ToastBanners extends Component {
	render(){
		var toast;
		if(store.unseenNotifications.length){
			toast = store.unseenNotifications[0];
		}

		const isAchievement = !!toast && !!toast.Data && !!toast.Data.Achieve;
		return (
			<React.Fragment>
				<Top>
					<Positioner>
						<AnimatePresence>
							{isAchievement && (
								<AchievementToast key={toast.ConfirmationKey} toast={toast}/>
							)}
						</AnimatePresence>
					</Positioner>
				</Top>
			</React.Fragment>
		);
	}
}
